import React from 'react'

import { ListGrid, StyleboardGroupItem } from '@pb/components'
import { getLabelFromStorage } from '@pb/utils' // REMOVE
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import appSelectors from 'App/duck/selectors'
import { STYLEBOARDS } from 'features/favourites/constants'
import { Styleboard, StyleboardStatus } from 'features/Styleboard/types'

import { createStyleboardButtonTrigger } from '../../labels'
import { StyleboardsComponentProps } from '../../types'

const Styleboards: React.FC<StyleboardsComponentProps> = ({
  styleboards,
  setIsCreateModalOpen,
}) => {
  const history = useHistory()
  const isSmallScreen = useSelector(appSelectors.getIsSmallScreen)

  const createdStyleboards = styleboards.map((styleboard: Styleboard) => {
    const { image, status, title, totalNoItems, followers, id } = styleboard

    const styleboardTotalItemsLabel =
      totalNoItems === 1 ? 'styleboard.item.count.single' : 'styleboard.item.count'
    const styleboardFollowersLabel =
      followers === 1 ? 'styleboard.followers.count.single' : 'styleboard.followers.count'
    const subHeading = `${getLabelFromStorage(styleboardTotalItemsLabel, {
      replacements: totalNoItems || 0,
    })} | ${getLabelFromStorage(styleboardFollowersLabel, {
      replacements: followers || 0,
    })}`

    return (
      <StyleboardGroupItem
        key={id}
        id={id}
        Tag="button"
        images={[{ id: title, src: image }]}
        imageAltText="" // TODO: add label when received
        privateStyleboard={status === StyleboardStatus.PRIVATE && isSmallScreen}
        privateText={getLabelFromStorage('styleboard.private')}
        shouldShowPrivateText={status === StyleboardStatus.PRIVATE}
        heading={title}
        subHeading={subHeading}
        onStyleboardGroupItemClick={() => {
          history.push(`/styleboard/${id}`)
        }}
        orientation={isSmallScreen ? 'landscape' : 'portrait'}
      />
    )
  })

  return (
    <ListGrid
      numberOfColumns={{
        xsmall: 1,
        small: 1,
        medium: 1,
        large: 2,
        xlarge: 3,
        xxl: 3,
      }}
      gridGap="large"
      shouldHaveItemFlex={false}
    >
      <StyleboardGroupItem
        id="createGroupItem"
        Tag="button"
        images={[{ id: 'create', src: STYLEBOARDS.CREATE_IMAGE }]}
        imageAltText={createStyleboardButtonTrigger}
        heading={createStyleboardButtonTrigger}
        onStyleboardGroupItemClick={() => setIsCreateModalOpen(true)}
        action={{
          showIndicator: true,
        }}
        orientation={isSmallScreen ? 'landscape' : 'portrait'}
        isImageCover={false}
      />
      {createdStyleboards}
    </ListGrid>
  )
}
export default Styleboards
